const getAvatarInitials = textString => {
  if (!textString) {
    return '#';
  }

  const text = textString.trim();

  const textSplit = text.split(' ');

  if (textSplit.length <= 1) {
    return text.charAt(0);
  }

  const initials = textSplit[0].charAt(0) + textSplit[textSplit.length - 1].charAt(0);

  return initials;
};

export { getAvatarInitials }; // eslint-disable-line import/prefer-default-export
